import { Trans } from "@lingui/react";

const ServicePlanFollowed = () => {
  return (
    <p className="mb-0">
      <Trans
        id="itemPageLayout.safetyElement.servicePlanFollowed.info"
        message="The vehicle's service program has been followed. Services have been performed on the vehicle according to the manufacturer's guidelines."
      />
    </p>
  );
};

export default ServicePlanFollowed;
